export default __webpack_public_path__ + "static/media/dry-erase.79031c1e.jpeg";